export const PRODUCT_NAME = "Pickleball Game Explorer";
export const PRODUCT_STAGE = "Beta";
export const PRODUCT_NAME_WITH_STAGE = `${PRODUCT_NAME} ${PRODUCT_STAGE}`;
export const PRODUCT_NAME_WITH_STAGE_PARENS = `${PRODUCT_NAME} (${PRODUCT_STAGE.toLowerCase()})`;
export const COPYRIGHT_TEXT = `© 2026 ${PRODUCT_NAME}`;
export const CREATOR_NAME = "Brad Lyon";
export const CONTACT_EMAIL = "bradflyon@gmail.com";
export const EXPORT_ATTRIBUTION_LINE_1 = `Created with ${PRODUCT_NAME_WITH_STAGE}`;
export const EXPORT_ATTRIBUTION_LINE_2 = `${CREATOR_NAME} • ${CONTACT_EMAIL}`;
